<div class="platform-contact">
  <div class="page-header">
    <div>
      <h2>平台联系人</h2>
      <p>维护平台客服电话、邮箱与二维码，供 C 端展示。</p>
    </div>
    <button type="button" class="primary-btn" :disabled="loading || saving" @click="openCreateModal">
      新增联系人
    </button>
  </div>

  <div class="filter-panel">
    <label class="filter-item">
      <span>状态</span>
      <select v-model="filterState" :disabled="loading" @change="handleStateFilterChange">
        <option value="">全部</option>
        <option value="1">启用</option>
        <option value="0">禁用</option>
      </select>
    </label>
    <button type="button" class="secondary-btn" :disabled="loading" @click="resetFilters">重置</button>
  </div>

  <div class="table-container">
    <div v-if="loading" class="loading-wrapper">
      <div class="loading-spinner"></div>
      <span>加载中...</span>
    </div>

    <div v-else class="table-scroll">
      <table class="data-table">
        <thead>
          <tr>
            <th class="qr-col">二维码</th>
            <th>ID</th>
            <th>电话</th>
            <th>邮箱</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>更新时间</th>
            <th class="action-col">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="contactList.length === 0">
            <td colspan="8" class="empty-text">暂无联系人配置</td>
          </tr>
          <tr v-else v-for="item in contactList" :key="item.id">
            <td class="qr-col">
              <img v-if="pickQrCodeUrl(item)" :src="pickQrCodeUrl(item)" class="qr-thumb" alt="二维码" />
              <span v-else class="qr-placeholder">无</span>
            </td>
            <td>{{ item.id }}</td>
            <td>{{ item.phone || '—' }}</td>
            <td>{{ item.email || '—' }}</td>
            <td>
              <span :class="item.state === 1 ? 'state-active' : 'state-disabled'">
                {{ pickStateLabel(item.state) }}
              </span>
            </td>
            <td>{{ formatDate(item.created_at) }}</td>
            <td>{{ formatDate(item.updated_at) }}</td>
            <td class="action-col">
              <button type="button" class="action-btn edit-btn" :disabled="saving" @click="openEditModal(item)">
                编辑
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="!loading && contactList.length > 0" class="pagination">
      <button type="button" class="page-btn" :disabled="currentPage <= 1" @click="handlePageChange(currentPage - 1)">
        上一页
      </button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页 · 共 {{ total }} 条</span>
      <button
        type="button"
        class="page-btn"
        :disabled="currentPage >= totalPages"
        @click="handlePageChange(currentPage + 1)"
      >
        下一页
      </button>
    </div>
  </div>

  <div v-if="modalVisible" class="modal-mask" @click="closeModal">
    <div class="modal-panel" @click.stop>
      <div class="modal-header">
        <h3>{{ modalTitle }}</h3>
        <button type="button" class="close-btn" @click="closeModal">×</button>
      </div>

      <div v-if="detailLoading" class="modal-loading">加载详情中...</div>
      <div v-else class="modal-body">
        <label class="form-row">
          <span>客服电话</span>
          <input v-model="form.phone" type="text" placeholder="400-xxx-xxxx" maxlength="50" />
        </label>
        <label class="form-row">
          <span>客服邮箱</span>
          <input v-model="form.email" type="email" placeholder="support@example.com" maxlength="100" />
        </label>
        <div class="form-row">
          <span>联系二维码</span>
          <div class="qr-upload">
            <div class="qr-preview">
              <img v-if="form.qr_code_url" :src="form.qr_code_url" alt="二维码" />
              <span v-else>暂无二维码</span>
            </div>
            <button type="button" class="secondary-btn" :disabled="uploadingImage" @click="triggerQrUpload">
              {{ uploadingImage ? '上传中...' : '上传二维码' }}
            </button>
          </div>
        </div>
        <label class="form-row form-row-narrow">
          <span>状态</span>
          <select v-model.number="form.state">
            <option :value="1">启用</option>
            <option :value="0">禁用</option>
          </select>
        </label>
        <p class="hint-text">电话、邮箱、二维码至少填写一项；编辑时仅更新已填写的字段。</p>
      </div>

      <div class="modal-actions">
        <input
          ref="fileInputRef"
          class="hidden-input"
          type="file"
          accept="image/*"
          @change="handleSelectQrImage"
        />
        <button type="button" class="secondary-btn" :disabled="saving || detailLoading || uploadingImage" @click="closeModal">
          取消
        </button>
        <button type="button" class="primary-btn" :disabled="saving || detailLoading || uploadingImage" @click="handleSave">
          {{ saving ? '保存中...' : '保存' }}
        </button>
      </div>
    </div>
  </div>
</div>
